<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}条{{ query.categoryName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" type="danger" class="btn" size="small" :disabled="multiple" v-preventReClick @click="handleDelete">批量删除</el-button>
        </div>
        <div class="right">
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>
      <el-tabs v-model="query.buyOrSale" @tab-click="handleClick" stretch>
        <el-tab-pane v-for="item in PurchasePaymentTypeOptions" :key="item.id" :name="item.id">
          <template slot="label">
            <span style="margin: 0 10px"> {{ item.name }} </span>
          </template>
        </el-tab-pane>
      </el-tabs>
      <el-table ref="multipleTable" border row-key="id" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
        </el-table-column>
        <template v-for="(item, index) in tableColumn">
          <el-table-column :key="index" :align="item.align" :label="item.label" :prop="item.prop" :fixed="item.fixed" :formatter="item.formatter" :show-overflow-tooltip="item.tooltip" :width="item.width" :min-width="item.minWidth" v-if="item.type == 'ware'">
            <template slot-scope="scope">
              <div>
                {{
                  item.formatters.formatter1
                    ? item.formatters.formatter1(
                        null,
                        null,
                        scope.row[item.rowData.data1]
                      )
                    : scope.row[item.rowData.data1]
                }}
              </div>
              <div>
                {{
                  item.formatters.formatter2
                    ? item.formatters.formatter2(
                        null,
                        null,
                        scope.row[item.rowData.data2]
                      )
                    : scope.row[item.rowData.data2]
                }}
              </div>
            </template>
          </el-table-column>
          <!-- 日期 -->
          <el-table-column :key="index" :align="item.align" :label="item.label" :prop="item.prop" :fixed="item.fixed" :formatter="item.formatter" :show-overflow-tooltip="item.tooltip" :width="item.width" v-else-if="item.type == 'Date'">
            <template slot-scope="scope">
              <div>
                {{ parseTime(new Date(scope.row[item.prop]), "{y}-{m}-{d}") }}
              </div>
            </template>
          </el-table-column>
          <!-- 时间 -->
          <el-table-column :key="index" :align="item.align" :label="item.label" :prop="item.prop" :fixed="item.fixed" :formatter="item.formatter" :show-overflow-tooltip="item.tooltip" :width="item.width" v-else-if="item.type == 'DateTime'">
            <template slot-scope="scope">
              <div>
                {{ parseTime(new Date(scope.row[item.prop]), "{y}-{m}-{d}") }}
              </div>
              <div>
                {{ parseTime(new Date(scope.row[item.prop]), "{h}:{i}:{s}") }}
              </div>
            </template>
          </el-table-column>
          <!-- 普通列 -->
          <el-table-column v-else :key="index" :align="item.align" :label="item.label" :prop="item.prop" :fixed="item.fixed" :formatter="item.formatter" :show-overflow-tooltip="item.tooltip" :width="item.width"></el-table-column>
        </template>
        <el-table-column prop="state" :label="query.buyOrSale == '0' ? '请款状态' : '收款状态'" width="100" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.state == 0" style="color:#E8873D">
              {{ query.buyOrSale == "0" ? "未付款" : "未收款" }}
            </div>
            <div v-else-if="scope.row.state == 1" style="color:#6EA204">
              {{ query.buyOrSale == "0" ? "部分付款" : "部分收款" }}
            </div>
            <div v-else-if="scope.row.state == 2" style="color:#CE1126">
              已完成
            </div>
          </template>
        </el-table-column>
        <el-table-column v-if="isWorkflowTable" label="审批人" width="100" align="center" prop="approverNames" />
        <el-table-column prop="statusName" label="流程状态" width="80" v-if="isWorkflowTable">
          <template slot-scope="scope">
            <approve-status :row="scope.row" :isWorkflowTable="isWorkflowTable" :options="ApproveStatusOptions" @success="getData" :tableCode="route.name"></approve-status>
          </template>
        </el-table-column>
        <el-table-column prop="operation" label="操作" width="180">
          <template slot-scope="scope">
            <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button>
            <el-button v-if="CanEdit(scope.row) && tableAcl.indexOf('Edit') != -1" type="text" v-preventReClick @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
            <el-button v-else-if="
                scope.row.status == 1 &&
                  isShowApproveButton(scope.row.approverIds)
              " type="text" v-preventReClick @click="handleApprove(scope.row)" class="margin-left20 color-blue">审核</el-button>
            <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span>
            <el-button v-if="
                query.buyOrSale != 0 &&
                  tableAcl.indexOf('Remove') != -1 &&
                  scope.row.state == 0
              " type="text" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
            <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import GetDataMixin from "@/mixin/getData-mixin.js";
import { PurchasePaymentTypeOptions } from "@/enum";
import {
  GetPurchasePayments,
  RemovePurchasePayments,
  GetSalesCollections,
  RemoveSalesCollections,
} from "@/api";
export default {
  mixins: [GetDataMixin],
  components: {},
  /** 定义属性 */
  data () {
    return {
      PurchasePaymentTypeOptions: PurchasePaymentTypeOptions,
      tableColumn: [],
      tableColumn1: [
        {
          label: "物资请款单号",
          prop: "no",
          width: "180",
        },
        {
          label: "厂商信息",
          prop: "manufacturerName",
          minWidth: "140",
          tooltip: true,
          formatter: this.manufacturerInfoFormatter,
        },
        {
          label: "请款人",
          prop: "userName",
          minWidth: "100",
        },
        {
          type: "Date",
          label: "创建时间",
          prop: "createdTime",
          width: "140",
        },
        {
          label: "请款金额",
          prop: "totalAmount",
          minWidth: "120",
          formatter: this.toDecimal4,
        },
        {
          label: "备注",
          prop: "remark",
          minWidth: "150",
          tooltip: true,
        },
      ],
      tableColumn2: [
        {
          label: "售出收款单号",
          prop: "no",
          width: "180",
        },
        {
          label: "厂商信息",
          prop: "manufacturerName",
          minWidth: "140",
          tooltip: true,
          formatter: this.manufacturerInfoFormatter,
        },
        {
          label: "收款人",
          prop: "userName",
          minWidth: "100",
        },
        {
          type: "Date",
          label: "创建时间",
          prop: "createdTime",
          width: "140",
        },
        {
          label: "收款金额",
          prop: "totalAmount",
          minWidth: "120",
          formatter: this.toDecimal4,
        },
        {
          label: "备注",
          prop: "remark",
          minWidth: "150",
          tooltip: true,
        },
      ],
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        buyOrSale: "0",
        categoryName: "采购付款",
      },
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
      // 多选框数据
      ids: [],
      multipleSelection: [],
      // 列表多选
      multiple: true,
    };
  },
  /** 计算属性，会监听依赖属性值随之变化 */
  computed: {},
  /** 监控data中的数据变化 */
  watch: {},
  /** 方法集合 */
  methods: {
    refenceQuery () {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        buyOrSale: "0",
        categoryName: "采购付款",
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
    },
    // 改变当前页
    changePage (val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange (val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },
    queryChange () {
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },
    handleClick (tab) {
      // this.query.buyOrSale =
      let item = this.PurchasePaymentTypeOptions.find((e) => e.id == tab.name);
      if (item) {
        this.query.categoryName = item.name;
      }
      switch (tab.index) {
        case "0":
          this.tableColumn = this.tableColumn1;
          break;
        case "1":
          this.tableColumn = this.tableColumn2;
          break;
      }
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },
    // 重置
    reset () {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        buyOrSale: "0",
        categoryName: "采购付款",
        orgCode :sessionStorage.getItem('orgId')
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
      this.ids = []
      this.multipleSelection = []
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection()
      }
      this.getData();
    },
    getData () {
      if (this.query.buyOrSale == 0) {
        GetPurchasePayments(this.query).then((res) => {
          this.tableData = res.returnData.data;
          this.total = res.returnData.totalCount;
        });
      } else {
        GetSalesCollections(this.query).then((res) => {
          this.tableData = res.returnData.data;
          this.total = res.returnData.totalCount;
        });
      }
    },
    // 查看信息
    handleInfo (row) {
      this.$router.push(
        "/sales-collection-edit?formMode=0&id=" +
        row.id +
        "&buyOrSale=" +
        this.query.buyOrSale
      );
    },
    // 新建
    handleAdd () {
      this.$router.push(
        "/sales-collection-edit?formMode=1" +
        "&buyOrSale=" +
        this.query.buyOrSale
      );
    },
    // 编辑
    handleUpdate (row) {
      this.$router.push(
        "/sales-collection-edit?formMode=2&id=" +
        row.id +
        "&buyOrSale=" +
        this.query.buyOrSale
      );
    },
    // 审批
    handleApprove (row) {
      this.$router.push(
        "/sales-collection-edit?formMode=3&id=" +
        row.id +
        "&buyOrSale=" +
        this.query.buyOrSale
      );
    },
    handleDelete (row) {
      const ids = row && row.id ? [row.id] : this.ids;

      this.$my_confirm("此操作将删除数据，是否继续？", "提示", {
        type: "warning",
      })
        .then(() => {
          if (this.query.buyOrSale == 0) {
            return RemovePurchasePayments({ ids });
          } else {
            return RemoveSalesCollections({ ids });
          }
        })
        .then(() => {
          this.$my_message(`操作成功！`, "success");
          this.getData();
        })
        .catch(() => { });
    },
    handleSelectionChange (selection) {
      this.multipleSelection = selection;
      this.ids = selection.map((item) => item.id);
      this.multiple = !selection.length;
    },
    manufacturerInfoFormatter (row, column, cellValue, index) {
      switch (row.manufacturerInfoType) {
        case 0:
          // 供应商
          return row.supplierName;
          break;
        case 1:
          // 生产厂家
          return row.manufacturerName;
          break;
        case 2:
          // 维修厂商
          return row.repairManufacturerName;
          break;
      }
    },
    CanEdit (row) {
      if (this.isAdmin) {
        // 是管理员
        return true;
      } else if (this.userInfo.id == row.userId) {
        // 是请款人/收款人
        return true;
      } else if (this.userInfo.id == row.createdUser) {
        // 是创建人
        return true;
      } else {
        return false;
      }
    },
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
    this.tableColumn = this.tableColumn1;
  },
  /** 生命周期 - 挂载完成（可以访问DOM元素） */
  mounted () {
    this.getData();
  },
  /** 生命周期 - 创建之前 */
  beforeCreate () { },
  /** 生命周期 - 挂载之前 */
  beforeMount () { },
  /** 生命周期 - 更新之前 */
  beforeUpdate () { },
  /** 生命周期 - 更新之后 */
  updated () { },
  /** 生命周期 - 销毁之前 */
  beforeDestroy () { },
  /** 生命周期 - 销毁完成 */
  destroyed () { },
  /** 如果页面有keep-alive缓存功能，这个函数会触发 */
  activated () { },
};
</script>

<style lang="scss" scoped>
.el-tabs {
  width: 200px;
  margin-bottom: 10px;
}
</style>
